<template>
  <div>
    <!-- Start signIn as someone else block -->
    <SignIn />
    <!-- End signIn as someone else block -->
    <BoxNotification
      v-if="isProductSubscription && !canUserPurchaseSubscriptionProduct"
      class="multiple-subscription"
      :notificationState="'warning'">
      <p slot="message" class="m-boxNotification__Message">
        <span class="m-boxNotification__Message--Bold">Heads up </span>
        - This account has an active {{ ownedSubscriptionGroup }} subscription.
        Visit <span class="m-boxNotification__Message--Account">My Account</span> to view details
        <a href="https://account.serato.com/#/subscriptions" rel="noopener noreferrer" class="m-boxNotification__Message--ManagePlan">
          <button class="a-Button--Small a-Button--notifications a-Button--notifications--warning">Manage</button>
        </a>
      </p>
    </BoxNotification>
    <BoxNotification
      v-else-if="!userCanUpgradeProduct"
      class="multiple-subscription"
      :notificationState="'messageNotification'">
      <p slot="message" class="m-boxNotification__Message">
        Sorry, there’s no 
        <span class="m-boxNotification__Message--Bold m-boxNotification__Message__Product">Pitch ’n Time </span>
        upgrade available for this account.
        If you wish to change your plan please follow the link below.
        <a v-bind:href="changeUserUrl" v-if="changeUserUrl" rel="noopener noreferrer" class="m-boxNotification__Message--ChangePlan">
          <button class="a-Button--Medium a-Button--LightBlue">Sign in as someone else</button>
        </a>
        <a href="/pitchntime" v-if="changeUserUrl" rel="noopener noreferrer" class="m-boxNotification__Message--ChangePlan">
          <button class="a-Button--Medium a-Button--LightBlue">Buy Pitch’n Time</button>
        </a>
      </p>
    </BoxNotification>
    <!-- Start payment div -->
    <div v-else class="p-payment">
      <OrderSummary ref="orderSummary" />
      <!-- Start checkout-form div -->
      <PaymentsDetails ref="paymentsDetails" />
      <!-- End checkout-form div -->
    </div>
    <!-- End payment div -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SignIn from '../molecules/SignIn.vue'
import BoxNotification from '../molecules/BoxNotification.vue'
import OrderSummary from '../organisms/OrderSummary.vue'
import PaymentsDetails from '../organisms/PaymentsDetails.vue'

export default {
  computed: mapState({
    isFetchingUser: state => state.user.fetchingUser,
    isFetchingCart: state => state.cart.fetchingCart,
    userId: state => state.user.id,
    changeUserUrl: state => state.globalstate.changeUserUrl,
    items: state => state.cart.items,
    purchasableUpgrades: state => state.user.purchasableUpgrades,
    purchaseableSubsProducts: state => state.user.purchaseableSubsProducts,
    isProductSubscription: state => state.cart.isSubscription,
    gtmCheckoutName: state => state.globalstate.gtmCheckoutName,
    loading () {
      return this.isFetchingCart || this.isFetchingUser
    },
    userCanUpgradeProduct () {
      if (this.userId && this.items && this.items.length !== 0) {
        for (var item in this.items) {
          if (
            this.items[item].product_type.isUpgrade &&
            this.purchasableUpgrades.length === 0 &&
            !this.purchasableUpgrades.includes(this.items[item].product_type.sku)
          ) {
            return false
          }
        }
      }
      return true
    },
    canUserPurchaseSubscriptionProduct () {
      // IF purchasableSubsProducts is null or has empty value set by mutation,
      // it means that the user does not have any existing subscriptions and they can buy anything.
      // So no need for any sort of checks.
      if (this.purchaseableSubsProducts !== null && this.purchaseableSubsProducts !== '') {
        // IF the user has an existing subscription, let us check if this product is in the
        // purchasableSubsProducts array.
        // Assumption: There is only one subscription product in cart at a time.
        const item = this.items[0]
        if (Object.values(this.purchaseableSubsProducts).indexOf(item.product_type.id) > -1) {
          return true
        } else {
          // IF the item is not in purchasableSubsProducts array, let us setup the messaging for the error message
          // to show.
          if ('subscription_group' in item.product_type) {
            this.ownedSubscriptionGroup = this.getFullSubscriptionGroupName(item.product_type.subscription_group)
          }
          return false
        }
      }
      return true
    }
  }),
  components: {
    SignIn,
    BoxNotification,
    OrderSummary,
    PaymentsDetails
  },
  watch: {
    isFetchingUser (newValue) {
      return newValue
    },
    isFetchingCart (newValue) {
      return newValue
    },
    loading () {
      if (this.isFetchingCart === false && this.isFetchingUser === false) {
        if (this.items === undefined || this.userId === '') {
          this.$router.push({ path: '/cart' })
        }
      }
    }
  },
  data () {
    return {
      ownedSubscriptionGroup: '',
      producerDJProductId: 154
    }
  },
  methods: {
    getFullSubscriptionGroupName (subscriptionName) {
      // IF the product is producer DJ bundle, the messaging would not depend on the subscription group.
      // We can only buy one subscription product at a time.
      if (this.items[0].product_type.id === this.producerDJProductId) {
        return 'Serato'
      } else if (subscriptionName === 'dj') {
        return 'Serato DJ'
      } else if (subscriptionName === 'sample') {
        return 'Serato Sample'
      } else if (subscriptionName === 'serato_studio') {
        return 'Serato Studio'
      } else {
        return ''
      }
    },
    gtmLoadTrigger () {
      this.$gtm.trackEvent({
        'event': 'eec-checkout',
        'checkout_type': this.gtmCheckoutName,
        'userId': this.userId,
        'ecommerce': {
          'checkout': {
            'actionField': { 'step': 2 }
          }
        }
      })
    }
  },
  created () {
    this.$store.dispatch('globalstate/updateHeaderCaption', 'Payment')
    this.$store.dispatch('globalstate/updateShowOrderTotal', true)
  },
  mounted () {
    this.gtmLoadTrigger()
    this.$store.dispatch('globalstate/fetch')
  }
}
</script>



// WEBPACK FOOTER //
// Payment.vue?0f4606b3